import src from "IMAGE";
export default { src, width: 903, height: 568, blurWidth: 0, blurHeight: 0};
